﻿/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';

export default class KDMZPunchoutForm extends TKCustomElementFactory {
    submitBtn?: HTMLButtonElement;

    constructor() {
        super();
        this.submitBtn = this.querySelector('button[data-op-oci-url]') as HTMLButtonElement;
    }

    connectedCallback() {
        super.connectedCallback();

        if (this.submitBtn) {
            this.pushListener({ event: 'click', element: this.submitBtn, action: this.handleButtonClick.bind(this) });
        }
    }

    handleButtonClick(event: Event): void {
        if (!this.submitBtn) return;
        event.preventDefault();
        fetchRequest({
            requestURL: this.submitBtn.getAttribute('data-op-oci-url')!,
            resolveHandler: this.renderResult.bind(this),
            decodeJSONResponse: false,
        });
    }

    renderResult(response) {
        if (!response) return;
        // const html = render(response);
        this.querySelector('.kdmz-punchout-form__content')!.insertAdjacentHTML('afterbegin', response);
        this.querySelector('form')!.submit();
    }
}
